import Vue from 'vue'
let _instances = [];

const SwiperDirective = {
	inserted (el, viewOptions, vnode) {

		let element = viewOptions.value.element

		const sampleOptions = {
			direction: 'horizontal',
			slidesPerView: 1,
			// spaceBetween: 30,
			// preloadImages: false,
			lazy: {
    			loadPrevNext: true,
  			},
			autoplay: false,
			mousewheel: {
				forceToAxis: true,
				releaseOnEdges: true,
				invert: true
			},
			touchReleaseOnEdges: true,
			resistanceRatio: 0,
			pagination: {
				el: `${element}-pagination`,
                clickable: true,
                // dynamicBullets: true
			}
		}

		let options = Object.assign({}, sampleOptions, viewOptions.value.options)

		let swiper = new Swiper(element, options)

		_instances.push(swiper)
	},
	unbind (el, viewOptions, vnode) {
		for (let i of _instances) {
			i.destroy(true, true)
		}

		_instances = []
	}
}

const SwiperNext = {
	inserted (el, viewOptions, vnode) {
		let next = function () {
			let swiper = document.querySelector(viewOptions.value.element).swiper

			swiper.slideNext();
		}

		el.addEventListener('click', next)
	}
}

const SwiperPrev = {
	inserted (el, viewOptions, vnode) {
		let prev = function () {
			let swiper = document.querySelector(viewOptions.value.element).swiper

			swiper.slidePrev();
		}

		el.addEventListener('click', prev)
	}
}

export { SwiperDirective, SwiperNext, SwiperPrev }